import React from 'react';

const Button = ({ className, children, isDisabled, ...otherProps }) => (
  <button className={`Button ${className}`} disabled={isDisabled} {...otherProps}>
    {children}
  </button>
);

export default Button;
